// extracted by mini-css-extract-plugin
module.exports = {"selectedOption":"localSelect_selectedOption__i54Op","dropdownMenu":"localSelect_dropdownMenu__WdF9p","fadeIn":"localSelect_fadeIn__lHiQ4","option":"localSelect_option__MGnND"};